import lyyDialog from './lyyDialog';

export default {
  mount(Vue) {
    Vue.component('lyy-Dialog', lyyDialog);
  },
  install(Vue) {
    const lyyDialogInstance = Vue.extend(lyyDialog);
    let lyyDialogInit;
    const initInstance = () => {
      lyyDialogInit = new lyyDialogInstance(); // 初始化一个组件实例
      const lyyDialogEl = lyyDialogInit.$mount().$el; // 组件注册到页面中
      document.body.appendChild(lyyDialogEl);
    };
    Vue.$lyyDialog = Vue.prototype.$lyyDialog = {
      alert(options) {
        if (!lyyDialogInit) { // 防止生成多个实例
          initInstance();
        }
        Vue.nextTick(() => {
          lyyDialogInit.alert(options);
        });
      },
      confirm(options) {
        if (!lyyDialogInit) {
          initInstance();
        }
        Vue.nextTick(() => {
          lyyDialogInit.confirm(options);
        });
      },
      closeFun() {
        lyyDialogInit.closeFun();
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/common/lyyDialog/config.js